import { default as localeEN } from '@lynx/core/src/services/translations/locale-en-GB.json'import { default as localeAF } from '@lynx/core/src/services/translations/generated/locale-af-AF.json'
import { default as localeDE } from '@lynx/core/src/services/translations/generated/locale-de-DE.json'
import { default as localeDK } from '@lynx/core/src/services/translations/generated/locale-da-DK.json'
import { default as localeEE } from '@lynx/core/src/services/translations/generated/locale-et-EE.json'
import { default as localeES } from '@lynx/core/src/services/translations/generated/locale-es-ES.json'
import { default as localeFI } from '@lynx/core/src/services/translations/generated/locale-fi-FI.json'
import { default as localeFR } from '@lynx/core/src/services/translations/generated/locale-fr-FR.json'
import { default as localeGR } from '@lynx/core/src/services/translations/generated/locale-el-GR.json'
import { default as localeIT } from '@lynx/core/src/services/translations/generated/locale-it-IT.json'
import { default as localeLV } from '@lynx/core/src/services/translations/generated/locale-lv-LV.json'
import { default as localeNL } from '@lynx/core/src/services/translations/generated/locale-nl-NL.json'
import { default as localePL } from '@lynx/core/src/services/translations/generated/locale-pl-PL.json'
import { default as localeRU } from '@lynx/core/src/services/translations/generated/locale-ru-RU.json'
import { default as localeSE } from '@lynx/core/src/services/translations/generated/locale-sv-SE.json'
//
import { default as localeAR } from '@lynx/core/src/services/translations/generated/locale-ar-AR.json'
import { default as localeBG } from '@lynx/core/src/services/translations/generated/locale-bg-BG.json'
import { default as localeCA } from '@lynx/core/src/services/translations/generated/locale-ca-CA.json'
import { default as localeCY } from '@lynx/core/src/services/translations/generated/locale-cy-CY.json'
import { default as localeCS } from '@lynx/core/src/services/translations/generated/locale-cs-CZ.json'
import { default as localeFO } from '@lynx/core/src/services/translations/generated/locale-fo-FO.json'
import { default as localeGL } from '@lynx/core/src/services/translations/generated/locale-gl-GL.json'
import { default as localeHE } from '@lynx/core/src/services/translations/generated/locale-he-HE.json'
import { default as localeKY } from '@lynx/core/src/services/translations/generated/locale-ky-KG.json'
import { default as localeHR } from '@lynx/core/src/services/translations/generated/locale-hr-HR.json'
import { default as localeHU } from '@lynx/core/src/services/translations/generated/locale-hu-HU.json'
import { default as localeIE } from '@lynx/core/src/services/translations/generated/locale-ga-IE.json'
import { default as localeIS } from '@lynx/core/src/services/translations/generated/locale-is-IS.json'
import { default as localeLT } from '@lynx/core/src/services/translations/generated/locale-lt-LT.json'
import { default as localeMK } from '@lynx/core/src/services/translations/generated/locale-mk-MK.json'
import { default as localeNO } from '@lynx/core/src/services/translations/generated/locale-nb-NO.json'
import { default as localePT } from '@lynx/core/src/services/translations/generated/locale-pt-PT.json'
import { default as localeRO } from '@lynx/core/src/services/translations/generated/locale-ro-RO.json'
import { default as localeSI } from '@lynx/core/src/services/translations/generated/locale-sl-SI.json'
import { default as localeSK } from '@lynx/core/src/services/translations/generated/locale-sk-SK.json'
import { default as localeSQ } from '@lynx/core/src/services/translations/generated/locale-sq-SQ.json'
import { default as localeSR } from '@lynx/core/src/services/translations/generated/locale-sr-SR.json'
import { default as localeTR } from '@lynx/core/src/services/translations/generated/locale-tr-TR.json'
import { default as localeZHHant } from '@lynx/core/src/services/translations/generated/locale-zh-Hant-ZH.json'
import { default as localeZH } from '@lynx/core/src/services/translations/generated/locale-zh-ZH.json'
import { default as localeUK } from '@lynx/core/src/services/translations/generated/locale-uk-UK.json'
import { default as localeTH } from '@lynx/core/src/services/translations/generated/locale-th-TH.json'
import { default as localeKK } from '@lynx/core/src/services/translations/generated/locale-kk-KZ.json'
import { default as localeUZ } from '@lynx/core/src/services/translations/generated/locale-uz-UZ.json'
import { default as localeTK } from '@lynx/core/src/services/translations/generated/locale-tk-TM.json'
import { default as localeTG } from '@lynx/core/src/services/translations/generated/locale-tg-TJ.json'

export { localeEN }

export const i18nextDefaultOptions = {
	resources: {
		af: { translation: localeAF },
		da: { translation: localeDK },
		de: { translation: localeDE },
		el: { translation: localeGR },
		en: { translation: localeEN },
		es: { translation: localeES },
		et: { translation: localeEE },
		fi: { translation: localeFI },
		fr: { translation: localeFR },
		it: { translation: localeIT },
		lv: { translation: localeLV },
		nl: { translation: localeNL },
		pl: { translation: localePL },
		ru: { translation: localeRU },
		sv: { translation: localeSE },
		ky: { translation: localeKY },
		kk: { translation: localeKK },
		ar: { translation: localeAR },
		bg: { translation: localeBG },
		ca: { translation: localeCA },
		cy: { translation: localeCY },
		cs: { translation: localeCS },
		fo: { translation: localeFO },
		gl: { translation: localeGL },
		he: { translation: localeHE },
		hr: { translation: localeHR },
		hu: { translation: localeHU },
		ie: { translation: localeIE },
		is: { translation: localeIS },
		lt: { translation: localeLT },
		mk: { translation: localeMK },
		nb: { translation: localeNO },
		pt: { translation: localePT },
		ro: { translation: localeRO },
		sl: { translation: localeSI },
		sk: { translation: localeSK },
		sq: { translation: localeSQ },
		sr: { translation: localeSR },
		tr: { translation: localeTR },
		th: { translation: localeTH },
		tg: { translation: localeTG },
		tk: { translation: localeTK },
		uz: { translation: localeUZ },
		['zh-Hant']: { translation: localeZHHant },
		zh: { translation: localeZH },
		uk: { translation: localeUK }
	},
	fallbackLng: 'en',
	debug: false,
	interpolation: {
		escapeValue: false // not needed for react as it escapes by default
	}
}
